// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - App Settings Configuration
// ═══════════════════════════════════════════════════════════════════════════
// Edit this file to change app behavior without touching code.
// ═══════════════════════════════════════════════════════════════════════════

export const SETTINGS = {
  // ─────────────────────────────────────────────────────────────────────────
  // SESSION MANAGEMENT
  // ─────────────────────────────────────────────────────────────────────────
  
  // How many verses before showing a reflection prompt
  versesPerSession: 7,
  
  // Seconds to pause between verses (0 = no pause, 10 = sacred silence)
  pauseBetweenVerses: 0,
  
  // Show occasional "dwell on this" verses that require lingering
  showDivineVerse: true,
  
  // How often to show a Divine Verse (every N verses)
  divineVerseFrequency: 15,
  
  // Seconds the user must linger on a Divine Verse
  divineVersePauseDuration: 8,
  
  // Detect rapid scrolling and offer to pause
  detectRapidScrolling: true,
  
  // How fast is "too fast" (verses per 10 seconds)
  rapidScrollThreshold: 5,
  
  // ─────────────────────────────────────────────────────────────────────────
  // UI BEHAVIOR
  // ─────────────────────────────────────────────────────────────────────────
  
  // Vibration feedback on actions (if device supports)
  enableHaptics: true,
  
  // Subtle sounds (paper swipe, soft chime)
  enableSounds: false,
  
  // Default theme: 'light', 'dark', or 'dawn'
  defaultTheme: 'light',
  
  // Allow users to switch themes
  enableThemeSwitching: true,
  
  // ─────────────────────────────────────────────────────────────────────────
  // SPIRITUAL SAFEGUARDS
  // ─────────────────────────────────────────────────────────────────────────
  
  // Show reflection questions at end of session
  enableReflectionPrompts: true,
  
  // Show blessing and saved verses at session end
  enableSessionEndRitual: true,
  
  // Allow expanding verse context (dive deeper)
  showVerseContext: true,
  
  // Show curated verses for first-time users
  enableOnboarding: true,
  
  // ─────────────────────────────────────────────────────────────────────────
  // FEATURE TOGGLES
  // Set to false to disable any feature
  // ─────────────────────────────────────────────────────────────────────────
  features: {
    favorites: true,        // Heart button to save verses
    sharing: true,          // Share button
    diveDeeper: true,       // Context expansion panel
    onboarding: true,       // First-time poetic intro
    symbols: true,          // Decorative overlays (seed, flame, etc.)
    journaling: false,      // Future: add notes to saved verses
    weeklyTrace: false,     // Future: weekly summary
  },
  
  // ─────────────────────────────────────────────────────────────────────────
  // STORAGE
  // ─────────────────────────────────────────────────────────────────────────
  
  // Key prefix for localStorage
  storagePrefix: 'writtn_',
  
  // Maximum saved verses (oldest removed when exceeded)
  maxSavedVerses: 500,
};

export default SETTINGS;
